function applyParallaxScroll(selector, breakpoint) {
  if ($(selector).length) {
    $(window).on('scroll load', function () {
      var pixels = window.scrollY * 0.3;
      var transformValue = $(window).width() <= breakpoint
        ? 'translate(0, -' + pixels + 'px) rotate(90deg)'
        : 'translate(-' + pixels + 'px, 0)';
      $(selector).css({ transform: transformValue });
    });
  }
}

applyParallaxScroll('.module--usps__content__slide', 991.98);
applyParallaxScroll('.module--reviews__content__slide', 1199.98);
